import { type ReactElement, type ReactNode, isValidElement } from 'react';

import { DefaultItem, GenericItem } from '../types';

type ElementWithChildren = ReactElement<{
  children?: ReactNode;
}>;

const reactNodeToString = (reactNode: ReactNode): string => {
  if (typeof reactNode === 'string') {
    return reactNode;
  }

  if (typeof reactNode === 'number') {
    return reactNode.toString();
  }

  if (Array.isArray(reactNode)) {
    return reactNode.map(reactNodeToString).join(' ');
  }

  if (isValidElement(reactNode)) {
    return reactNodeToString((reactNode as ElementWithChildren).props.children);
  }

  return '';
};

export const defaultLabelGetter = (item: unknown | null): string => {
  return item ? reactNodeToString((item as DefaultItem).label) : '';
};

const defaultFilterBy = (item: string, inputValue: string) =>
  item.includes(inputValue);

export const defaultGetFilteredItems = <TItem extends GenericItem>({
  allItems,
  itemToString,
  inputValue,
  filterBy = defaultFilterBy,
}: {
  allItems: TItem[];
  itemToString: (item: TItem | null) => string;
  inputValue?: string;
  filterBy?: (item: string, inputValue: string) => boolean;
}) => {
  if (!inputValue) {
    return allItems;
  }

  return allItems.filter((item) =>
    filterBy(itemToString(item).toLowerCase(), inputValue.toLowerCase()),
  );
};

export const defaultIsItemDisabled = (
  item: GenericItem | undefined,
  _index?: number,
) => !!item?.disabled;
